var exports = {
  "GT": "UploadDropZone.module__dropZone___cEFhV2",
  "xf": "UploadDropZone.module__dropZoneDragging___cEFhV2",
  "Kk": "UploadDropZone.module__icon___cEFhV2",
  "h_": "UploadDropZone.module__description___cEFhV2",
};

module.exports = exports;
